import { Href } from 'redux-little-router';

import { BaseBannerInfoField } from '../components/BannersBaseInfoEditor/BannersBaseInfoEditor';
import { BannerSummaryErrorParams } from '../service/BannerEditErrors/ErrorsTextMapper/ErrorsTextMapper';
import { ApiMethodExecutingError } from '../service/Errors';
import { captureException } from '../service/ErrorsReporting/ErrorsReporting';
import {
    BannerId,
    BannersEditBaseInfoData,
    BannersEditData,
    BannersToClear,
    CampaignInfoForBannerCreation,
    GroupInfoForBannerCreation,
    PrevEditedBannerId,
    SaveBannersResult,
    VcardData,
    VCardsCampaignsDataInfo
} from '../typings/banners';
import {
    EditedBanner,
    EditedBannerVideo,
    InvalidBannerPromocodes,
    NewBannerInputData,
    NewPerformanceBannerInputData
} from '../typings/bannersEditState';
import { ValidationErrorData } from '../typings/common';
import { AdvType, AdvTypeClient, BannerImageFormat, CampaignId } from '../typings/domain';
import { CurrencyCode } from '../typings/graphql-grid';
import { BannersEditMassActionItemType, GroupId } from '../typings/groups';
import { VideoState } from '../typings/video';

export const RESET_BANNERS_EDIT = 'RESET_BANNERS_EDIT';
export const GET_BANNERS_FOR_EDIT = 'GET_BANNERS_FOR_EDIT';
export const GET_BASE_INFO_FOR_BANNER_CREATION = 'GET_BASE_INFO_FOR_BANNER_CREATION';
export const GET_BREAD_CRUMBS_BANNER = 'GET_BREAD_CRUMBS_BANNER';
export const UPDATE_BANNERS_FOR_EDIT = 'UPDATE_BANNERS_FOR_EDIT';
export const UPDATE_BANNER_BASE_INFO = 'UPDATE_BANNER_BASE_INFO';
export const UPDATE_BANNERS_EDIT_BASE_INFO_DATA = 'UPDATE_BANNERS_EDIT_BASE_INFO_DATA';
export const UPDATE_BANNERS_EDIT_GROUP_DATA_FOR_PERFORMANCE_CREATION =
    'UPDATE_BANNERS_EDIT_GROUP_DATA_FOR_PERFORMANCE_CREATION';
export const UPDATE_BANNER_CONTACTS_FOR_USER = 'UPDATE_BANNER_CONTACTS_FOR_USER';
export const REMOVE_BANNER_VIDEO = 'REMOVE_BANNER_VIDEO';
export const UPDATE_MAIN_LINK = 'UPDATE_MAIN_LINK';
export const CHECK_PROMOCODES_AND_PREPARE_BANNERS = 'CHECK_PROMOCODES_AND_PREPARE_BANNERS';
export const SHOW_INVALID_BANNERS_PROMOCODES = 'SHOW_INVALID_BANNERS_PROMOCODES';
export const CLOSE_INVALID_PROMOCODES_MODAL = 'CLOSE_INVALID_PROMOCODES_MODAL';
export const SAVE_BANNERS = 'SAVE_BANNERS';
export const SAVE_BANNERS_SUCCESS = 'SAVE_BANNERS_SUCCESS';
export const SET_DEFAULT_BANNER_SITELINKS = 'SET_DEFAULT_BANNER_SITELINKS';
export const SHOW_BANNER_EDIT_REQUEST_ERROR = 'SHOW_BANNER_EDIT_REQUEST_ERROR';
export const SHOW_BANNER_EDIT_SUMMARY_ERROR = 'SHOW_BANNER_EDIT_SUMMARY_ERROR';

export const EDIT_BANNER = 'EDIT_BANNER';

export const ADD_NEW_TEXT_BANNERS = 'ADD_NEW_TEXT_BANNERS';
export const CREATE_NEW_TEXT_BANNER = 'CREATE_NEW_TEXT_BANNER';
export const CREATE_NEW_MC_BANNER = 'CREATE_NEW_MC_BANNER';
export const CREATE_NEW_CPM_BANNER = 'CREATE_NEW_CPM_BANNER';
export const CREATE_NEW_CONTENT_PROMOTION_BANNER = 'CREATE_NEW_CONTENT_PROMOTION_BANNER';
export const ADD_NEW_PERFORMANCE_BANNERS = 'ADD_NEW_PERFORMANCE_BANNERS';
export const DELETE_BANNERS = 'DELETE_BANNERS';
export const CLEAR_BANNERS = 'CLEAR_BANNERS';
export const CLEAR_TURBOLANDING_EDITOR = 'CLEAR_TURBOLANDING_EDITOR';
export const RESTORE_BANNERS = 'RESTORE_BANNERS';
export const COPY_BANNER = 'COPY_BANNER';
export const CHANGE_BANNER_TYPE = 'CHANGE_BANNER_TYPE';

export const LEAVE_BANNERS_EDIT = 'LEAVE_BANNERS_EDIT';

export type RESET_BANNERS_EDIT = typeof RESET_BANNERS_EDIT;
export type GET_BANNERS_FOR_EDIT = typeof GET_BANNERS_FOR_EDIT;
export type GET_BASE_INFO_FOR_BANNER_CREATION = typeof GET_BASE_INFO_FOR_BANNER_CREATION;
export type GET_BREAD_CRUMBS_BANNER = typeof GET_BREAD_CRUMBS_BANNER;
export type UPDATE_BANNERS_FOR_EDIT = typeof UPDATE_BANNERS_FOR_EDIT;
export type UPDATE_BANNERS_EDIT_BASE_INFO_DATA = typeof UPDATE_BANNERS_EDIT_BASE_INFO_DATA;
export type UPDATE_BANNERS_EDIT_GROUP_DATA_FOR_PERFORMANCE_CREATION = typeof UPDATE_BANNERS_EDIT_GROUP_DATA_FOR_PERFORMANCE_CREATION;
export type UPDATE_BANNER_BASE_INFO = typeof UPDATE_BANNER_BASE_INFO;
export type UPDATE_BANNER_CONTACTS_FOR_USER = typeof UPDATE_BANNER_CONTACTS_FOR_USER;
export type REMOVE_BANNER_VIDEO = typeof REMOVE_BANNER_VIDEO;
export type UPDATE_MAIN_LINK = typeof UPDATE_MAIN_LINK;
export type CHECK_PROMOCODES_AND_PREPARE_BANNERS = typeof CHECK_PROMOCODES_AND_PREPARE_BANNERS;
export type SHOW_INVALID_BANNERS_PROMOCODES = typeof SHOW_INVALID_BANNERS_PROMOCODES;
export type CLOSE_INVALID_PROMOCODES_MODAL = typeof CLOSE_INVALID_PROMOCODES_MODAL;
export type SAVE_BANNERS = typeof SAVE_BANNERS;
export type SET_DEFAULT_BANNER_SITELINKS = typeof SET_DEFAULT_BANNER_SITELINKS;
export type SAVE_BANNERS_SUCCESS = typeof SAVE_BANNERS_SUCCESS;
export type SHOW_BANNER_EDIT_REQUEST_ERROR = typeof SHOW_BANNER_EDIT_REQUEST_ERROR;
export type SHOW_BANNER_EDIT_SUMMARY_ERROR = typeof SHOW_BANNER_EDIT_SUMMARY_ERROR;
export type EDIT_BANNER = typeof EDIT_BANNER;

export type ADD_NEW_TEXT_BANNERS = typeof ADD_NEW_TEXT_BANNERS;
export type CREATE_NEW_TEXT_BANNER = typeof CREATE_NEW_TEXT_BANNER;
export type CREATE_NEW_MC_BANNER = typeof CREATE_NEW_MC_BANNER;
export type CREATE_NEW_CPM_BANNER = typeof CREATE_NEW_CPM_BANNER;
export type CREATE_NEW_CONTENT_PROMOTION_BANNER = typeof CREATE_NEW_CONTENT_PROMOTION_BANNER;
export type ADD_NEW_PERFORMANCE_BANNERS = typeof ADD_NEW_PERFORMANCE_BANNERS;
export type DELETE_BANNERS = typeof DELETE_BANNERS;
export type CLEAR_BANNERS = typeof CLEAR_BANNERS;
export type CLEAR_TURBOLANDING_EDITOR = typeof CLEAR_TURBOLANDING_EDITOR;
export type RESTORE_BANNERS = typeof RESTORE_BANNERS;
export type COPY_BANNER = typeof COPY_BANNER;
export type CHANGE_BANNER_TYPE = typeof CHANGE_BANNER_TYPE;
export type LEAVE_BANNERS_EDIT = typeof LEAVE_BANNERS_EDIT;

export interface ClearTurbolandingEditor {
    type: CLEAR_TURBOLANDING_EDITOR;
    bannerIds: string[];
}

export function clearTurbolandingEditor(bannerIds: string[]): ClearTurbolandingEditor {
    return {
        type: CLEAR_TURBOLANDING_EDITOR,
        bannerIds
    };
}

export interface ResetBannersEdit {
    type: RESET_BANNERS_EDIT;
}

export function resetBannersEdit(): ResetBannersEdit {
    return {
        type: RESET_BANNERS_EDIT
    };
}

export interface GetBannersForEdit {
    type: GET_BANNERS_FOR_EDIT;
    login: string;
}

export function getBannersForEdit(login: string): GetBannersForEdit {
    return {
        type: GET_BANNERS_FOR_EDIT,
        login
    };
}

export interface GetBaseInfoForBannerCreation {
    type: GET_BASE_INFO_FOR_BANNER_CREATION;
    login: string;
    campaignsIds: Array<string>;
    groupIds: Array<GroupId>;
}

export function getBaseInfoForBannerCreation(
    login: string,
    campaignsIds: Array<string>,
    groupIds: Array<GroupId>
): GetBaseInfoForBannerCreation {
    return {
        type: GET_BASE_INFO_FOR_BANNER_CREATION,
        login,
        campaignsIds,
        groupIds
    };
}

export interface UpdateBannersForEdit {
    type: UPDATE_BANNERS_FOR_EDIT;
    data: BannersEditData;
    reqId: string;
}

export function updateBannersForEdit(bannersData: BannersEditData, reqId: string): UpdateBannersForEdit {
    return {
        type: UPDATE_BANNERS_FOR_EDIT,
        data: bannersData,
        reqId
    };
}

export interface UpdateBannersEditBaseInfoData {
    type: UPDATE_BANNERS_EDIT_BASE_INFO_DATA;
    data: BannersEditBaseInfoData;
    login: string;
}

export function updateBannersEditBaseInfoData(
    data: BannersEditBaseInfoData,
    login: string
): UpdateBannersEditBaseInfoData {
    return {
        type: UPDATE_BANNERS_EDIT_BASE_INFO_DATA,
        data,
        login
    };
}

export interface UpdateBannerBaseInfo {
    type: UPDATE_BANNER_BASE_INFO;
    bannerId: BannerId;
    changed: {
        field: BaseBannerInfoField;
        value: string;
    };
}

export function updateBannerBaseInfo(
    bannerId: BannerId,
    changed: {
        field: BaseBannerInfoField;
        value: string;
    }
): UpdateBannerBaseInfo {
    return {
        type: UPDATE_BANNER_BASE_INFO,
        bannerId,
        changed
    };
}

export interface CheckPromocodesAndPrepareBanners {
    type: CHECK_PROMOCODES_AND_PREPARE_BANNERS;
}

export function checkPromocodesAndPrepareBanners(): CheckPromocodesAndPrepareBanners {
    return {
        type: CHECK_PROMOCODES_AND_PREPARE_BANNERS
    };
}

export interface ShowInvalidBannersPromocodes {
    type: SHOW_INVALID_BANNERS_PROMOCODES;
    promocodes: InvalidBannerPromocodes;
}

export function showInvalidBannersPromocodes(promocodes: InvalidBannerPromocodes): ShowInvalidBannersPromocodes {
    return {
        type: SHOW_INVALID_BANNERS_PROMOCODES,
        promocodes
    };
}

export interface CloseInvalidPromocodesModalAction {
    type: CLOSE_INVALID_PROMOCODES_MODAL;
}

export function closeInvalidPromocodesModal(): CloseInvalidPromocodesModalAction {
    return {
        type: CLOSE_INVALID_PROMOCODES_MODAL
    };
}

export interface SaveBanners {
    type: SAVE_BANNERS;
}

export function saveBanners(): SaveBanners {
    return {
        type: SAVE_BANNERS
    };
}

export interface SetDefaultBannerSitelinks {
    type: SET_DEFAULT_BANNER_SITELINKS;
    bannerId: BannerId;
}

export function setDefaultBannerSitelinks(bannerId: BannerId): SetDefaultBannerSitelinks {
    return {
        type: SET_DEFAULT_BANNER_SITELINKS,
        bannerId
    };
}

export interface SaveBannersSuccess {
    type: SAVE_BANNERS_SUCCESS;
    result: SaveBannersResult;
}

export function saveBannersSuccess(result: SaveBannersResult): SaveBannersSuccess {
    return {
        type: SAVE_BANNERS_SUCCESS,
        result
    };
}

export interface ShowBannerEditRequestError {
    type: SHOW_BANNER_EDIT_REQUEST_ERROR;
    error: ValidationErrorData;
}

export function showBannerEditRequestError(error: ApiMethodExecutingError | string): ShowBannerEditRequestError {
    if (error instanceof ApiMethodExecutingError) {
        captureException(error.getNativeError(), {
            extra: {
                requestOptions: error.getRequestOptions()
            }
        });

        return {
            type: SHOW_BANNER_EDIT_REQUEST_ERROR,
            error: {
                code: 'showBannerEditRequestError',
                text: error.getMessage()
            }
        };
    } else {
        captureException(new Error(error));
        throw error;
    }
}

export interface ShowBannerEditSummaryError {
    type: SHOW_BANNER_EDIT_SUMMARY_ERROR;
    error: BannerSummaryErrorParams;
}

export function showBannerEditSummaryError(error: BannerSummaryErrorParams): ShowBannerEditSummaryError {
    return {
        type: SHOW_BANNER_EDIT_SUMMARY_ERROR,
        error
    };
}

export interface EditBanner {
    type: EDIT_BANNER;
    bannerId: BannerId;
}

export function editBanner(bannerId: BannerId): EditBanner {
    return {
        type: EDIT_BANNER,
        bannerId
    };
}

export interface AddNewTextBannersAction {
    type: ADD_NEW_TEXT_BANNERS;
    banners: NewBannerInputData[];
    autoGeneratedVideo: VideoState;
}

export function addNewTextBanners(
    banners: NewBannerInputData[],
    autoGeneratedVideo: VideoState
): AddNewTextBannersAction {
    return {
        type: ADD_NEW_TEXT_BANNERS,
        banners,
        autoGeneratedVideo
    };
}

export interface CreateNewTextBannerAction {
    type: CREATE_NEW_TEXT_BANNER;
    campaign: CampaignInfoForBannerCreation;
    group: GroupInfoForBannerCreation;
    video?: EditedBannerVideo;
    bannerId: BannerId;
    vCardId?: string;
}

export function createNewTextBanner(
    campaign: CampaignInfoForBannerCreation,
    group: GroupInfoForBannerCreation,
    bannerId: BannerId,
    video?: EditedBannerVideo,
    vCardId?: string
): CreateNewTextBannerAction {
    return {
        type: CREATE_NEW_TEXT_BANNER,
        campaign,
        video,
        group,
        bannerId,
        vCardId
    };
}

export interface CreateNewMcBannerAction {
    type: CREATE_NEW_MC_BANNER;
    campaign: CampaignInfoForBannerCreation;
    group: GroupInfoForBannerCreation;
    bannerId: BannerId;
}

export function createNewMcBanner(
    campaign: CampaignInfoForBannerCreation,
    group: GroupInfoForBannerCreation,
    bannerId: BannerId
): CreateNewMcBannerAction {
    return {
        type: CREATE_NEW_MC_BANNER,
        campaign,
        group,
        bannerId
    };
}

export interface CreateNewContentPromotionBanner {
    type: CREATE_NEW_CONTENT_PROMOTION_BANNER;
    campaign: CampaignInfoForBannerCreation;
    group: GroupInfoForBannerCreation;
    bannerId: BannerId;
}

export function createNewContentPromotionBanner(
    campaign: CampaignInfoForBannerCreation,
    group: GroupInfoForBannerCreation,
    bannerId: BannerId
): CreateNewContentPromotionBanner {
    return {
        type: CREATE_NEW_CONTENT_PROMOTION_BANNER,
        campaign,
        group,
        bannerId
    };
}

export interface CreateNewCpmBannerAction {
    type: CREATE_NEW_CPM_BANNER;
    campaign: CampaignInfoForBannerCreation;
    group: GroupInfoForBannerCreation;
    bannerId: BannerId;
}

export function createNewCpmBanner(
    campaign: CampaignInfoForBannerCreation,
    group: GroupInfoForBannerCreation,
    bannerId: BannerId
): CreateNewCpmBannerAction {
    return {
        type: CREATE_NEW_CPM_BANNER,
        campaign,
        group,
        bannerId
    };
}

export interface UpdateBannersEditGroupDataForPerformanceCreation {
    type: UPDATE_BANNERS_EDIT_GROUP_DATA_FOR_PERFORMANCE_CREATION;
    campaign: CampaignInfoForBannerCreation;
    group: GroupInfoForBannerCreation;
}

export function updateBannersEditGroupDataForPerformanceCreation(
    campaign: CampaignInfoForBannerCreation,
    group: GroupInfoForBannerCreation
): UpdateBannersEditGroupDataForPerformanceCreation {
    return {
        type: UPDATE_BANNERS_EDIT_GROUP_DATA_FOR_PERFORMANCE_CREATION,
        campaign,
        group
    };
}

export interface AddNewPerformanceBannersAction {
    type: ADD_NEW_PERFORMANCE_BANNERS;
    banners: NewPerformanceBannerInputData[];
}

export function addNewPerformanceBanners(banners: NewPerformanceBannerInputData[]): AddNewPerformanceBannersAction {
    return {
        type: ADD_NEW_PERFORMANCE_BANNERS,
        banners
    };
}

export interface DeleteBanners {
    type: DELETE_BANNERS;
    bannersIds: BannerId[];
}

export function deleteBanners(bannersIds: BannerId[]): DeleteBanners {
    return {
        type: DELETE_BANNERS,
        bannersIds
    };
}

export interface ClearBanners {
    type: CLEAR_BANNERS;
    bannersToClear: BannersToClear;
    workCurrency: CurrencyCode;
}

export function clearBanners(
    bannersToClear: BannersToClear,
    workCurrency: CurrencyCode // TODO DIRECT-104016 вынести workCurrency в редьюсер очистки, тут он не нужен, точно
): ClearBanners {
    return {
        type: CLEAR_BANNERS,
        bannersToClear,
        workCurrency
    };
}

export interface RestoreBanners {
    type: RESTORE_BANNERS;
    bannersIds: Array<BannerId>;
}

export function restoreBanners(bannersIds: Array<BannerId>): RestoreBanners {
    return {
        type: RESTORE_BANNERS,
        bannersIds
    };
}

export interface CopyBanner {
    type: COPY_BANNER;
    bannerId: BannerId;
    newBannerId: BannerId;
}

export function copyBanner(bannerId: BannerId, newBannerId: BannerId): CopyBanner {
    return {
        type: COPY_BANNER,
        bannerId,
        newBannerId
    };
}

export const COPY_PREV_BANNER = 'COPY_PREV_BANNER';
export type COPY_PREV_BANNER = typeof COPY_PREV_BANNER;

export interface CopyPrevBanner {
    type: COPY_PREV_BANNER;
    bannerId: BannerId;
    newBannerId: BannerId;
}

export function copyPrevBanner(bannerId: BannerId, newBannerId: BannerId): CopyPrevBanner {
    return {
        type: COPY_PREV_BANNER,
        bannerId,
        newBannerId
    };
}

export interface ChangeBannerType {
    type: CHANGE_BANNER_TYPE;
    bannerId: string;
    bannerType: AdvType | AdvTypeClient;
}

export function changeBannerType(bannerId: string, bannerType: AdvType | AdvTypeClient): ChangeBannerType {
    return {
        type: CHANGE_BANNER_TYPE,
        bannerId,
        bannerType
    };
}

export const UPDATE_BANNER_EDIT_IMAGE_FORMATS = 'UPDATE_BANNER_EDIT_IMAGE_FORMATS';
export type UPDATE_BANNER_EDIT_IMAGE_FORMATS = typeof UPDATE_BANNER_EDIT_IMAGE_FORMATS;

export interface UpdateBannerEditImageFormatsAction {
    type: UPDATE_BANNER_EDIT_IMAGE_FORMATS;
    bannerId: BannerId;
    payload: Array<BannerImageFormat>;
}

export function updateBannerEditImageFormats(
    bannerId: BannerId,
    payload: Array<BannerImageFormat>
): UpdateBannerEditImageFormatsAction {
    return {
        type: UPDATE_BANNER_EDIT_IMAGE_FORMATS,
        bannerId,
        payload
    };
}

export interface LeaveBannersEdit {
    type: LEAVE_BANNERS_EDIT;
    location: Href;
}

export function leaveBannersEdit(location: Href): LeaveBannersEdit {
    return {
        type: LEAVE_BANNERS_EDIT,
        location
    };
}

export const HANDLE_BANNERS_EDIT_MASS_ACTIONS = 'HANDLE_BANNERS_EDIT_MASS_ACTIONS';
export type HANDLE_BANNERS_EDIT_MASS_ACTIONS = typeof HANDLE_BANNERS_EDIT_MASS_ACTIONS;

export interface HandleBannersEditMassActions {
    type: HANDLE_BANNERS_EDIT_MASS_ACTIONS;
    action: BannersEditMassActionItemType;
}

export function handleBannersEditMassActions(action: BannersEditMassActionItemType): HandleBannersEditMassActions {
    return {
        type: HANDLE_BANNERS_EDIT_MASS_ACTIONS,
        action
    };
}

export const PREPARE_BANNERS_BEFORE_SAVING = 'PREPARE_BANNERS_BEFORE_SAVING';
export type PREPARE_BANNERS_BEFORE_SAVING = typeof PREPARE_BANNERS_BEFORE_SAVING;

export interface PrepareBannersBeforeSavingAction {
    type: PREPARE_BANNERS_BEFORE_SAVING;
}

export function prepareBannersBeforeSaving(): PrepareBannersBeforeSavingAction {
    return {
        type: PREPARE_BANNERS_BEFORE_SAVING
    };
}

export const ON_ADD_NEW_TEXT_BANNER = 'ON_ADD_NEW_TEXT_BANNER';
export type ON_ADD_NEW_TEXT_BANNER = typeof ON_ADD_NEW_TEXT_BANNER;

export interface OnAddNewTextBanner {
    type: ON_ADD_NEW_TEXT_BANNER;
    banner: NewBannerInputData;
}

export function onAddNewTextBanner(banner: NewBannerInputData): OnAddNewTextBanner {
    return {
        type: ON_ADD_NEW_TEXT_BANNER,
        banner
    };
}

export const UPDATE_LAST_ADDED_VCARD_IDS = 'UPDATE_LAST_ADDED_VCARD_IDS';
export type UPDATE_LAST_ADDED_VCARD_IDS = typeof UPDATE_LAST_ADDED_VCARD_IDS;

export interface UpdateLastAddedVCardIds {
    type: UPDATE_LAST_ADDED_VCARD_IDS;
    vCardIds: Record<CampaignId, string | undefined>;
}

export function updateLastAddedVCardIds(vCardIds: Record<CampaignId, string | undefined>): UpdateLastAddedVCardIds {
    return {
        type: UPDATE_LAST_ADDED_VCARD_IDS,
        vCardIds
    };
}

export const UPDATE_VCARDS_FOR_EDIT = 'UPDATE_VCARDS_FOR_EDIT';
export type UPDATE_VCARDS_FOR_EDIT = typeof UPDATE_VCARDS_FOR_EDIT;

export interface UpdateVCardsForEdit {
    type: UPDATE_VCARDS_FOR_EDIT;
    vCards: Record<string, VcardData>;
}

export function updateVCardsForEdit(vCards: Record<string, VcardData>): UpdateVCardsForEdit {
    return {
        type: UPDATE_VCARDS_FOR_EDIT,
        vCards
    };
}

export const SAVE_VISITING_CARD_FOR_EDIT_BANNER = 'SAVE_VISITING_CARD_FOR_EDIT_BANNER';
export type SAVE_VISITING_CARD_FOR_EDIT_BANNER = typeof SAVE_VISITING_CARD_FOR_EDIT_BANNER;

export interface SaveVisitingCardForEditBanner {
    type: SAVE_VISITING_CARD_FOR_EDIT_BANNER;
    bannerIds: string[];
}

export function saveVisitingCardForEditBanner(bannerIds: string[]): SaveVisitingCardForEditBanner {
    return {
        type: SAVE_VISITING_CARD_FOR_EDIT_BANNER,
        bannerIds
    };
}

export const SAVE_SUCCESS_VISITING_CARD_FOR_EDIT_BANNERS = 'SAVE_SUCCESS_VISITING_CARD_FOR_EDIT_BANNERS';
export type SAVE_SUCCESS_VISITING_CARD_FOR_EDIT_BANNERS = typeof SAVE_SUCCESS_VISITING_CARD_FOR_EDIT_BANNERS;

export interface SaveSuccessVisitingCardForEditBanners {
    type: SAVE_SUCCESS_VISITING_CARD_FOR_EDIT_BANNERS;
    bannerIds: string[];
    vCardIds: string[];
}

export function saveSuccessVisitingCardForEditBanners(
    bannerIds: string[],
    vCardIds: string[]
): SaveSuccessVisitingCardForEditBanners {
    return {
        type: SAVE_SUCCESS_VISITING_CARD_FOR_EDIT_BANNERS,
        bannerIds,
        vCardIds
    };
}

export const CLEAR_VISITING_CARD_FOR_EDIT_BANNERS = 'CLEAR_VISITING_CARD_FOR_EDIT_BANNERS';
export type CLEAR_VISITING_CARD_FOR_EDIT_BANNERS = typeof CLEAR_VISITING_CARD_FOR_EDIT_BANNERS;

export interface ClearVisitingCardForEditBanners {
    type: CLEAR_VISITING_CARD_FOR_EDIT_BANNERS;
    bannerIds: string[];
}

export function clearVisitingCardForEditBanners(bannerIds: string[]): ClearVisitingCardForEditBanners {
    return {
        type: CLEAR_VISITING_CARD_FOR_EDIT_BANNERS,
        bannerIds
    };
}

export const GET_BANNERS_AUTO_GENERATED_VIDEO = 'GET_BANNERS_AUTO_GENERATED_VIDEO';
export type GET_BANNERS_AUTO_GENERATED_VIDEO = typeof GET_BANNERS_AUTO_GENERATED_VIDEO;

export interface GetBannersAutoGeneratedVideo {
    type: GET_BANNERS_AUTO_GENERATED_VIDEO;
    groupsIds: string[];
}

export function getBannersAutoGeneratedVideo(groupsIds: string[]): GetBannersAutoGeneratedVideo {
    return {
        type: GET_BANNERS_AUTO_GENERATED_VIDEO,
        groupsIds
    };
}

export const UPDATE_BANNERS_AUTO_GENERATED_VIDEO = 'UPDATE_BANNERS_AUTO_GENERATED_VIDEO';
export type UPDATE_BANNERS_AUTO_GENERATED_VIDEO = typeof UPDATE_BANNERS_AUTO_GENERATED_VIDEO;

export interface UpdateBannersAutoGeneratedVideo {
    type: UPDATE_BANNERS_AUTO_GENERATED_VIDEO;
    video: VideoState;
}

export function updateBannersAutoGeneratedVideo(video: VideoState): UpdateBannersAutoGeneratedVideo {
    return {
        type: UPDATE_BANNERS_AUTO_GENERATED_VIDEO,
        video
    };
}

export const CHANGE_BANNER_TYPE_ATTEMPT = 'CHANGE_BANNER_TYPE_ATTEMPT';
export type CHANGE_BANNER_TYPE_ATTEMPT = typeof CHANGE_BANNER_TYPE_ATTEMPT;

export interface ChangeBannerTypeAttempt {
    type: CHANGE_BANNER_TYPE_ATTEMPT;
    bannerId: string;
    bannerType: AdvType | AdvTypeClient;
}

export function changeBannerTypeAttempt(
    bannerId: string,
    bannerType: AdvType | AdvTypeClient
): ChangeBannerTypeAttempt {
    return {
        type: CHANGE_BANNER_TYPE_ATTEMPT,
        bannerId,
        bannerType
    };
}

export const REMOVE_CALLOUT_IDS_FROM_BANNERS = 'REMOVE_CALLOUT_IDS_FROM_BANNERS';
export type REMOVE_CALLOUT_IDS_FROM_BANNERS = typeof REMOVE_CALLOUT_IDS_FROM_BANNERS;

export interface RemoveCalloutsIdsFromBanners {
    type: REMOVE_CALLOUT_IDS_FROM_BANNERS;
    calloutsIds: string[];
}

export function removeCalloutsIdsFromBanners(calloutsIds: string[]): RemoveCalloutsIdsFromBanners {
    return {
        type: REMOVE_CALLOUT_IDS_FROM_BANNERS,
        calloutsIds
    };
}

export const ON_FETCH_PREV_EDITED_BANNER = 'ON_FETCH_PREV_EDITED_BANNER';
export type ON_FETCH_PREV_EDITED_BANNER = typeof ON_FETCH_PREV_EDITED_BANNER;

export interface OnFetchPrevEditedBanner {
    type: ON_FETCH_PREV_EDITED_BANNER;
    campaignId: CampaignId;
    bannerId: BannerId;
}

export function onFetchPrevEditedBanner(campaignId: CampaignId, bannerId: BannerId): OnFetchPrevEditedBanner {
    return {
        type: ON_FETCH_PREV_EDITED_BANNER,
        campaignId,
        bannerId
    };
}

export const LOAD_PREV_EDITED_BANNER = 'LOAD_PREV_EDITED_BANNER';
export type LOAD_PREV_EDITED_BANNER = typeof LOAD_PREV_EDITED_BANNER;

export interface LoadPrevEditedBanner {
    type: LOAD_PREV_EDITED_BANNER;
    bannerId: BannerId;
}

export function loadPrevEditedBanner(bannerId: BannerId): LoadPrevEditedBanner {
    return {
        type: LOAD_PREV_EDITED_BANNER,
        bannerId
    };
}

export const ON_COPY_PREV_EDITED_BANNER = 'ON_COPY_PREV_EDITED_BANNER';
export type ON_COPY_PREV_EDITED_BANNER = typeof ON_COPY_PREV_EDITED_BANNER;

export interface OnCopyPrevEditedBanners {
    type: ON_COPY_PREV_EDITED_BANNER;
    newBannerId: BannerId;
    bannerId: PrevEditedBannerId;
}

export function onCopyPrevEditedBanners(newBannerId: BannerId, bannerId: PrevEditedBannerId): OnCopyPrevEditedBanners {
    return {
        type: ON_COPY_PREV_EDITED_BANNER,
        bannerId,
        newBannerId
    };
}

export const ADD_PREV_EDITED_BANNER = 'ADD_PREV_EDITED_BANNER';
export type ADD_PREV_EDITED_BANNER = typeof ADD_PREV_EDITED_BANNER;

export interface AddPrevEditedBanners {
    type: ADD_PREV_EDITED_BANNER;
    data: Record<PrevEditedBannerId, EditedBanner>;
}

export function addPrevEditedBanners(data: Record<PrevEditedBannerId, EditedBanner>): AddPrevEditedBanners {
    return {
        type: ADD_PREV_EDITED_BANNER,
        data
    };
}

export const UPDATE_COMMON_VCARDS_DATA = 'UPDATE_COMMON_VCARDS_DATA';
export type UPDATE_COMMON_VCARDS_DATA = typeof UPDATE_COMMON_VCARDS_DATA;

export interface UpdateCommonVCardsData {
    type: UPDATE_COMMON_VCARDS_DATA;
    vCards: Record<string, VCardsCampaignsDataInfo>;
}

export function updateCommonVCardsData(vCards: Record<string, VCardsCampaignsDataInfo>): UpdateCommonVCardsData {
    return {
        type: UPDATE_COMMON_VCARDS_DATA,
        vCards
    };
}

export const UPDATE_DEFAULT_ORGANIZATIONS = 'UPDATE_DEFAULT_ORGANIZATIONS';
export type UPDATE_DEFAULT_ORGANIZATIONS = typeof UPDATE_DEFAULT_ORGANIZATIONS;

export interface UpdateDefaultOrganizations {
    type: UPDATE_DEFAULT_ORGANIZATIONS;
    defaultOrganizations: Record<CampaignId, string | undefined>;
}

export function updateDefaultOrganizations(
    defaultOrganizations: Record<CampaignId, string | undefined>
): UpdateDefaultOrganizations {
    return {
        type: UPDATE_DEFAULT_ORGANIZATIONS,
        defaultOrganizations
    };
}

export type BannersMultiEditActions =
    | GetBannersAutoGeneratedVideo
    | AddPrevEditedBanners
    | UpdateBannersAutoGeneratedVideo
    | OnCopyPrevEditedBanners
    | OnFetchPrevEditedBanner
    | LoadPrevEditedBanner
    | ResetBannersEdit
    | GetBannersForEdit
    | PrepareBannersBeforeSavingAction
    | GetBaseInfoForBannerCreation
    | UpdateBannersForEdit
    | UpdateBannersEditBaseInfoData
    | UpdateLastAddedVCardIds
    | UpdateBannerBaseInfo
    | UpdateCommonVCardsData
    | RemoveCalloutsIdsFromBanners
    | UpdateBannersEditGroupDataForPerformanceCreation
    | CheckPromocodesAndPrepareBanners
    | ShowInvalidBannersPromocodes
    | CloseInvalidPromocodesModalAction
    | SaveBanners
    | SetDefaultBannerSitelinks
    | SaveBannersSuccess
    | HandleBannersEditMassActions
    | ShowBannerEditRequestError
    | ShowBannerEditSummaryError
    | EditBanner
    | OnAddNewTextBanner
    | AddNewTextBannersAction
    | CreateNewTextBannerAction
    | CreateNewMcBannerAction
    | CreateNewContentPromotionBanner
    | CreateNewCpmBannerAction
    | AddNewPerformanceBannersAction
    | ChangeBannerType
    | DeleteBanners
    | ClearBanners
    | RestoreBanners
    | CopyPrevBanner
    | CopyBanner
    | UpdateBannerEditImageFormatsAction
    | LeaveBannersEdit
    | UpdateVCardsForEdit
    | SaveVisitingCardForEditBanner
    | SaveSuccessVisitingCardForEditBanners
    | ClearVisitingCardForEditBanners
    | ChangeBannerTypeAttempt
    | UpdateDefaultOrganizations
    | ClearTurbolandingEditor;
